import React from "react";
import { NavatticDemoModal } from "components/demo-embed";
import { Section } from "components/section";
import { BookDemoButton } from "components/event-tracking";
import { ProductShowcase, ProductShowcaseImage } from "ui/product-showcase";
import { TextTitle } from "ui/text";
import { desktopOnlyDisplay, mobileOnlyDisplay } from "utils";
import demoEmbedImage from "../../../../public/assets/solutions/data/demo-embed.png";
import mobileDemoEmbedImage from "../../../../public/assets/solutions/data/demo-embed-mobile.png";

const altText =
  "Hightouch Audiences interface. The audience is titled USA Active Customers and there are filters selected for users with country equal to usa, and those who viewed a product at least one time, within 7 days, where the price is greater than or equal to $50.";

export function DataDemoEmbed() {
  return (
    <Section>
      <TextTitle
        display={desktopOnlyDisplay("flex")}
        align="center"
        size="lg"
        maxW="740px"
        descriptionMaxW="620px"
        title="Enable self-serve activation of your complete data"
        description="Check out this 5 minute interactive demo to learn how your marketing team can build audiences, plan customer journeys, and gain insights from experiments."
        actions={<NavatticDemoModal hasRightChevron>Start exploring</NavatticDemoModal>}
      />
      <TextTitle
        display={mobileOnlyDisplay("flex")}
        align="center"
        size="lg"
        maxW="740px"
        title="Enable self-serve activation of your complete data"
        description="Talk to a product expert and learn how your marketing team can build audiences, plan customer journeys, and gain insights from experiments."
        actions={<BookDemoButton text="Book a demo" />}
      />
      <ProductShowcase
        mt={{ base: "bigger", md: "biggest" }}
        variant="autumn"
        productScreen={<ProductShowcaseImage src={demoEmbedImage} alt={altText} />}
        mobileProductScreen={<ProductShowcaseImage isMobile src={mobileDemoEmbedImage} alt={altText} />}
      />
    </Section>
  );
}
